import { Socket } from 'socket.io-client';
import { ComTxProtocol } from './socket.protocol';
import {
  ComSigninTx,
  ComSigninRx,
  ComParticipationTx,
  ComParticipationRx,
  ComEntryTx,
  ComEntryRx,
  ComEntryOrderTx,
  ComEntryOrderRx,
  ComEntryOrderPush,
  ComEntryCancelTx,
  ComEntryCancelRx,
  ComEntryCancelPush,
  ComNoticeUpdateTx,
  ComNoticeUpdateRx,
  ComEntrySiteUpdateTx,
  ComEntrySiteUpdateRx,
} from '../model/com.dto';

class SocketIO {
  private static _instance: SocketIO;
  private constructor() {
    this.socket = null;
  }
  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  socket: Socket | null;
  isAlive = false;
  isSignin = false;

  get isAliveCheck(): boolean {
    return this.isAlive;
  }

  get isSigninCheck(): boolean {
    return this.isSignin;
  }

  initialize(socket: Socket) {
    if (this.socket === null) {
      this.socket = socket;
      this.isAlive = true;
      this.isSignin = false;
      console.log('initialize', this.socket);
      return true;
    }
  }

  finalize() {
    this.socket = null;
    this.isAlive = false;
    this.isSignin = false;
    console.log('finalize', this.socket);
  }

  emit(ev: string, msg: any) {
    if (this.socket) {
      this.socket.emit(ev, msg);
    }
  }

  async emitAck(ev: string, msg: any) {
    try {
      if (this.socket) {
        return await this.socket.emitWithAck(ev, msg);
      } else {
        return { statusCode: 0, message: 'socket is null' };
      }
    } catch (err) {
      console.log(err);
      return { statusCode: 0, message: 'unknown error' };
    }
  }

  public async signin(accessToken: string): Promise<boolean> {
    const tx: ComSigninTx = { accessToken };
    const rx: ComSigninRx = await this.emitAck(ComTxProtocol.txSignin, tx);
    if (rx.statusCode === 200) {
      this.isSignin = true;
      return true;
    } else {
      this.isSignin = false;
      return false;
    }
  }

  public async participation(roomId: number): Promise<boolean> {
    const tx: ComParticipationTx = { roomId };
    const rx: ComParticipationRx = await this.emitAck(
      ComTxProtocol.txParticipation,
      tx,
    );
    return rx.statusCode === 200;
  }

  public async entry(lineId: number): Promise<boolean> {
    const tx: ComEntryTx = { lineId };
    const rx: ComEntryRx = await this.emitAck(ComTxProtocol.txEntry, tx);
    return rx.statusCode === 200;
  }

  public async entryOrder(entryId: number, lineId: number): Promise<boolean> {
    const tx: ComEntryOrderTx = { entryId, lineId };
    const rx: ComEntryOrderRx = await this.emitAck(
      ComTxProtocol.txEntryOrder,
      tx,
    );
    return rx.statusCode === 200;
  }

  public async entryCancel(entryId: number, lineId: number): Promise<boolean> {
    const tx: ComEntryCancelTx = { entryId, lineId };
    const rx: ComEntryCancelRx = await this.emitAck(
      ComTxProtocol.txEntryCancel,
      tx,
    );
    return rx.statusCode === 200;
  }

  public async noticeUpdate(roomId: number): Promise<boolean> {
    const tx: ComNoticeUpdateTx = { roomId };
    const rx: ComNoticeUpdateRx = await this.emitAck(
      ComTxProtocol.txNoticeUpdate,
      tx,
    );
    return rx.statusCode === 200;
  }

  public async entrySiteUpdate(roomId: number): Promise<boolean> {
    const tx: ComEntrySiteUpdateTx = { roomId };
    const rx: ComEntrySiteUpdateRx = await this.emitAck(
      ComTxProtocol.txEntrySiteUpdate,
      tx,
    );
    return rx.statusCode === 200;
  }
}

const socketio = SocketIO.instance;

export { socketio };
